<template>
  <div class="page">
    <sui-segment class="content" padded attached emphasis="secondary">
      <sui-container>
        <h2 class="ui header">
          <i class="briefcase grey icon" />
          <sui-header-content>New stack</sui-header-content>
        </h2>
        <br>
        <sui-form :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
          <FormStack v-model="entity" mode="importing" />
          <sui-message error v-if="apiErrors">
            {{apiErrors}}
          </sui-message>
        </sui-form>
      </sui-container>
      <div class="actions" :class="{selected: entity}">
        <sui-container>
          <div class="ui buttons">
            <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors" @click="submit()" data-goal="IMPORT_STACK_TRY">Confirm</sui-button>
          </div>
        </sui-container>
      </div>
    </sui-segment>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import pick from 'lodash/pick'
  import set from 'lodash/set'
  import some from 'lodash/some'
  import utils from '@/utils'
  import FormStack from '@/components/forms/Stack'
  import PageForm from '@/mixins/PageForm'

  export default {
    name: 'NewStackView',
    mixins: [
      PageForm,
    ],
    components: {
      FormStack,
    },
    computed: {
      ...mapGetters(['projects']),
      mode() {
        return 'importing'
      },
      queryParams() {
        const queryParams = {}
        const props = pick(this.$route.query, ['url', 'project'])
        for (const prop in props) {
          set(queryParams, prop, this.$route.query[prop])
        }
        const project = this.projects.find(entity => entity.id === this.$route.query.project || entity.name === this.$route.query.project) || {}
        if (project) {
          queryParams.project = project.id
        }
        return queryParams
      },
      pageProject() {
        const name = this.$route.params.project
        const project = this.projects.find(entity => entity.id === name || entity.name === name)
        return project
      },
      hasEntityErrors() {
        const hasHostErrors = this.entityErrors && this.entityErrors.hosts.filter(hostErrors => some(hostErrors)).length
        const hasServiceErrors = this.entityErrors && this.entityErrors.services.filter(serviceErrors => some(serviceErrors)).length
        return Boolean(this.entityErrors && (this.entityErrors.url || this.entityErrors.project || hasHostErrors || hasServiceErrors))
      },
    },
    methods: {
      onSuccess() {
        utils.reachGoal('IMPORT_STACK_SUCCESS')
        const entityProject = this.projects.find(project => project.id === this.entity.project)
        if (entityProject) {
          entityProject.openPage()
        }
      },
      onFail() {
        utils.reachGoal('IMPORT_STACK_FAIL')
      },
    },
    created() {
      this.visible = true
      this.entity = {
        url: null,
        project: null,
        ...this.queryParams,
        services: [],
        hosts: [],
      }
    },
  }

</script>

<style scoped>
  .page { display: flex; flex-direction: column; }
  .page > .content { flex: 1; padding: 2em 0 6em!important; }
  .content >>> .segment.secondary { background-color: #efefef!important; }
  .actions { position: fixed; bottom: -5em; left: 0; width: 100%; padding: 1em; border-top: 1px solid #ccc; background-color: #eee!important; z-index: 10; transition: bottom .5s; }
  .actions.selected { bottom: 0; }
</style>
